import * as Sentry from "@sentry/angular";
import { enableProdMode, APP_INITIALIZER, importProvidersFrom } from '@angular/core';

import { Title, Meta, BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { DatePipe } from "@angular/common";
import {
  FacebookLoginProvider,
  SOCIAL_AUTH_CONFIG,
  SocialAuthServiceConfig,
  SocialLoginModule
} from '@abacritt/angularx-social-login';
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { initUrls, initAuth, initApp} from './app/app.module';
import environment from './environments/environment';
import { UrlRedirectsService } from "./app/services/url-redirects.service";
import { AuthService } from "./app/services/auth.service";
import { ApiInterceptor } from "./app/http-interceptors/api-interceptor";
import { HttpXsrfInterceptor } from "./app/http-interceptors/xrsf-interceptor";
import { ErrorInterceptor } from "./app/http-interceptors/error-interceptor";
import { StrapiInterceptor } from "./app/strapi-interceptor.interceptor";
import { AppRoutingModule } from "./app/app-routing.module";
import { DashboardModule } from "./app/dashboard/dashboard.module";
import { LoginRegisterModule } from "./app/login-register/login-register.module";
import { ReportingSystemModule } from "./app/reporting-system/reporting-system.module";
import AppComponent from "./app/app.component";

Sentry.init({
    dsn: "https://4ad0d9f205e36f2ab66a7d13ce9decde@o4504293988368384.ingest.us.sentry.io/4505748283195392",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true
})

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(RouterModule, BrowserModule, HttpClientModule, SocialLoginModule, AppRoutingModule, DashboardModule, LoginRegisterModule, BrowserAnimationsModule, ReportingSystemModule),
        Title,
        Meta,
        DatePipe,
        UrlRedirectsService,
        {
            provide: APP_INITIALIZER,
            useFactory: initApp,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initAuth,
            deps: [AuthService],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initUrls,
            deps: [UrlRedirectsService],
            multi: true,
        },
        {
            provide: SOCIAL_AUTH_CONFIG,
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider(environment.facebook.appId, {
                            scopes: 'email,first_name,last_name',
                        }),
                    },
                ],
            } as SocialAuthServiceConfig,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpXsrfInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: StrapiInterceptor,
            multi: true,
        },
    ]
})
  .catch((err) => console.error(err));
